/** Path segments on the Kivunova marketing site (base URL from REACT_APP_KIVUNOVA_WEBSITE_URL). */
export const KIVUNOVA_WEBSITE_PATHS = {
  whoWeAre: "about-us",
  ourServices: "our-services",
  ourTeam: "our-team",
  terms: "terms-and-conditions",
  privacy: "privacy-and-policy",
  contactUs: "contact-us"
} as const;
